<script setup lang="ts">
import './assets/style.scss'
import PointMarker from '@/entities/Inventory/Main/ui/PointMarker.vue'
import { type PropType } from 'vue'
import { InventObject } from '@/widgets'

defineProps({
  item: {
    type: Object as PropType<InventObject>,
    required: true,
  },
  style: {
    type: Object,
    required: true,
  },
  small: {
    type: Boolean,
    default: false,
  },
  dot: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    :style="{ cursor: style.cursor }"
    class="v-invent-map-marker"
    :class="{ 'v-invent-map-marker_small': small && !dot, 'v-invent-map-marker_dot': dot }"
  >
    <PointMarker v-if="!dot" :style :subtype="item.getFigureSubType()" />
    <span v-else class="v-invent-map-marker__dot" :style="{ backgroundColor: style.fill }" />
  </div>
</template>
